import React from 'react';
import './question-modal.scss';
import { AlertCircle } from 'react-feather';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {
  useCloseOldModal,
  useModalData,
} from '../../../store/modal/modalHooks';

interface QuestionModalContentProps {
  title: string;
  subTitle: string;
  confirmButtonText: string;
  cancelButtonText: string;
}

const QuestionModal = ({
  title,
  subTitle,
  confirmButtonText,
  cancelButtonText,
}: QuestionModalContentProps) => {
  const closeModal = useCloseOldModal();
  const modalData = useModalData();

  const onConfirm = () => {
    if (modalData?.callback) {
      modalData?.callback();
    } else {
      closeModal();
    }
  };

  const onCancel = () => {
    if (modalData?.cancelCallback) {
      modalData.cancelCallback();
    } else {
      closeModal();
    }
  };

  return (
    <div className="question-modal">
      <ModalHeader>
        <div className="question-modal-header-title">
          <AlertCircle color="#ea5455" size={80} />
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="question-modal-title"> {title}</div>
        <div className="question-modal-sub-title"> {subTitle}</div>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onConfirm}>
          {confirmButtonText}
        </Button>{' '}
        <Button className="cancel-btn-modal" color="" onClick={onCancel}>
          {cancelButtonText}
        </Button>{' '}
      </ModalFooter>
    </div>
  );
};

export default QuestionModal;
